import { dmException } from '../../services/UnhandledExceptions';
import { dmLoading }   from '../loading/loading';

export class ExceptionViewModel {
    NewLoading:             (pMessage: string)                             => dmLoading;
    ExitApp:                ()                                             => void;
    CheckForLoggingFailure: ()                                             => boolean;
    RemoteLogException:     (pException: dmException, pAction: () => void) => void;

    Exceptions:             dmException[];

    constructor(
         pNewLoading:             (pMessage: string)                             => dmLoading
        ,pExitApp:                ()                                             => void
        ,pCheckForLoggingFailure: ()                                             => boolean
        ,pSetPageLoaded:          ()                                             => void
        ,pRemoteLogException:     (pException: dmException, pAction: () => void) => void
        ,pExceptions:             dmException[]
    ) {
        this.NewLoading             = pNewLoading;
        this.ExitApp                = pExitApp;
        this.CheckForLoggingFailure = pCheckForLoggingFailure;
        this.RemoteLogException     = pRemoteLogException;
        this.Exceptions             = pExceptions;

        pSetPageLoaded();

        if (
            (!this.CheckForLoggingFailure())
        &&  (this.Exceptions.length > 0)
        ) {
            this.logException(0);
        }
    }

    private logException(i: number): void {
        if (this.CheckForLoggingFailure()) { return; }

        let exception: dmException = this.Exceptions[i];

        if (exception.LogAttemptFinished) {
            if (i < (this.Exceptions.length - 1)) { this.logException(i++); }
        } else {
            let loading: dmLoading = this.NewLoading(
                'An error has occured. Sending error report, please wait...'
            );

            if (i < (this.Exceptions.length - 1)) {
                loading.Show(() => {
                    this.RemoteLogException(
                         exception
                        ,() => {
                            loading.Dismiss();

                            this.logException(i++);
                        }
                    );
                });
            } else {
                loading.Show(() => {
                    this.RemoteLogException(
                         exception
                        ,() => {
                            loading.Dismiss();
                        }
                    );
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/exception/xv-exception.ts